import { IQuery } from 'core-ts-types';
import { IDatasource, Query } from 'utility-ts-orm';
import { MajorDevCourse } from '../builders/major_dev_course_builder';

export class MajorDevCoursesQuery implements IQuery {
  private __result: MajorDevCourse[];

  constructor(private ngMajorDevCourseDatastore: IDatasource<MajorDevCourse>) {
    Query.registerQuery(this, this.ngMajorDevCourseDatastore);
  }

  run(): this {
    this.__result = this.ngMajorDevCourseDatastore.values();
    return this;
  }

  get result() {
    return this.__result;
  }
}

angular.module('major-explorer-data').service('ngMajorDevCoursesQuery', MajorDevCoursesQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/queries/major_dev_courses_query.ts